import _defineProperty from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React__default from 'react';
import classNames from 'classnames';
import FilledError from '../../icons/generated/filled/FilledError.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var CheckboxField = function CheckboxField(_a) {
  var _b = _a,
    _b$label = _b.label,
    label = _b$label === void 0 ? "Checkbox" : _b$label,
    id = _b.id,
    isChecked = _b.isChecked,
    disabled = _b.disabled,
    onChange = _b.onChange,
    required = _b.required,
    invalid = _b.invalid,
    _b$errorMessage = _b.errorMessage,
    errorMessage = _b$errorMessage === void 0 ? "Este campo \xE9 obrigat\xF3rio" : _b$errorMessage,
    props = __objRest(_b, ["label", "id", "isChecked", "disabled", "onChange", "required", "invalid", "errorMessage"]);
  var componentClass = classNames("iq-checkbox-field", _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "iq-checkbox-field--checked", !!isChecked), "iq-checkbox-field--disabled", !!disabled), "iq-checkbox-field--required", !!required), "iq-checkbox-field--invalid", !!invalid && !!required && !isChecked));
  var formattedLabel = required ? "".concat(label, " <span className=\"iq-checkbox-field__required-star\">", "*", "</span>") : "".concat(label);
  function onChangeHandler(e) {
    if (!!onChange) onChange(e.target.checked);
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: componentClass
  }, /* @__PURE__ */React__default.createElement("label", {
    htmlFor: id,
    className: "iq-checkbox-field__holder"
  }, /* @__PURE__ */React__default.createElement("input", __spreadValues({
    className: "iq-checkbox-field__input",
    id: id,
    type: "checkbox",
    checked: isChecked,
    disabled: disabled,
    onChange: onChangeHandler
  }, props)), /* @__PURE__ */React__default.createElement("span", {
    className: "iq-checkbox-field__icon"
  }), /* @__PURE__ */React__default.createElement("span", {
    className: "iq-checkbox-field__label",
    dangerouslySetInnerHTML: {
      __html: formattedLabel
    }
  })), /* @__PURE__ */React__default.createElement("div", {
    className: "iq-checkbox-field__invalid-holder"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "iq-checkbox-field__invalid-icon-holder"
  }, /* @__PURE__ */React__default.createElement(FilledError, {
    expand: true
  })), /* @__PURE__ */React__default.createElement("span", null, errorMessage)));
};
export { CheckboxField as default };